import React from "react";
import { Box } from "@mui/material";
import { FormField } from "../fields/FormField";
import { ProfileLogoField } from "../fields/ProfileLogoField";
import { ProfileFormGrid } from "../ProfileFormGrid";

export function DatiPubblici({
  vendorForm,
  fieldErrors,
  onChange,
  showLogoPreview,
  readOnly = false,
  fileInputRef,
  onFileChange,
  onRemoveLogo,
}) {
  const v = vendorForm ?? {};
  const err = fieldErrors ?? {};

  return (
    <Box sx={{ width: "100%" }}>
      <ProfileFormGrid>
        <FormField
          name="nomeCommerciale"
          value={v.nomeCommerciale}
          errorMessage={err.nomeCommerciale}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="sitowebAziendale"
          value={v.sitowebAziendale}
          errorMessage={err.sitowebAziendale}
          onChange={onChange}
          readOnly={readOnly}
        />
        <ProfileLogoField
          readOnly={readOnly}
          showLogoPreview={showLogoPreview}
          fileInputRef={fileInputRef}
          onFileChange={onFileChange}
          onRemoveLogo={onRemoveLogo}
        />
      </ProfileFormGrid>
    </Box>
  );
}
